module.exports = __webpack_public_path__ + "img/sum.78aba941.png";